import script from "./LoginPageCorp.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginPageCorp.vue?vue&type=script&setup=true&lang=ts"

import "./LoginPageCorp.vue?vue&type=style&index=0&id=6d74d378&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d74d378"]])

export default __exports__